(function () {

  function getProduct() {
    const el = document.getElementById('ProductJson');
    if (!el) return null;
    return JSON.parse(el.textContent);
  }

  function injectStyle() {
    if (!document.getElementById('variant-gallery-style')) {
      const style = document.createElement('style');
      style.id = 'variant-gallery-style';
      style.textContent = `.product__media-item.variant-hidden, .thumbnail-list__item.variant-hidden { display: none !important; }`;
      document.head.appendChild(style);
    }
  }

  function filterGallery(keyword) {
    if (!keyword) return;
    keyword = keyword.toLowerCase();
    injectStyle();

    const slides = document.querySelectorAll('.product__media-item, .thumbnail-list__item');
    console.log('Filtering for:', keyword, '| Slides found:', slides.length);

    slides.forEach(slide => {
      const img = slide.querySelector('img');
      if (!img) return;
      const alt = (img.alt || '').toLowerCase();
      console.log('  alt:', alt, '| match:', alt.includes(keyword));
      slide.classList.toggle('variant-hidden', !alt.includes(keyword));
    });
  }

  function getKeywordFromURL() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    const product = getProduct();
    if (!product) return null;
    const variant = variantId
      ? product.variants.find(v => v.id == variantId)
      : product.variants[0];
    return variant ? variant.title : null;
  }

  function runFilter() {
    const keyword = getKeywordFromURL();
    if (keyword) filterGallery(keyword);
  }

  // Watch the gallery container for DOM changes (theme rebuilding slides)
  function observeGallery() {
    const gallery = document.querySelector('.product__media-wrapper, [id*="GalleryViewer"], .product-media-container, form');
    if (!gallery) {
      console.warn('Gallery container not found');
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      const hasNewSlides = mutations.some(m =>
        [...m.addedNodes].some(n =>
          n.nodeType === 1 && (
            n.classList?.contains('product__media-item') ||
            n.querySelector?.('.product__media-item')
          )
        )
      );
      if (hasNewSlides) {
        console.log('New slides detected — refiltering');
        setTimeout(runFilter, 50);
      }
    });

    observer.observe(gallery, { childList: true, subtree: true });
    console.log('Gallery observer attached to:', gallery.className || gallery.id);
  }

  // Watch URL changes
  let lastUrl = location.href;
  new MutationObserver(function () {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      console.log('URL changed — running filter');
      runFilter();
    }
  }).observe(document.body, { childList: true, subtree: true });

  window.addEventListener('popstate', runFilter);

  // Init
  document.addEventListener('DOMContentLoaded', function () {
    injectStyle();
    observeGallery();
    runFilter();
  });

})();
